import { Routes } from "@angular/router";
import { AuthorizationGuard } from "@fpr/core/guards/authorization.guard";
import { RouteData } from "@fpr/core/models/route.models";
import { SessionGuard } from "@fpr/core/guards/session.guard";
import { ViewName } from "@fpr/core/models/session.models";

export const bookingRoutes: Routes = [
    {
        path: "create-party",
        loadChildren: () => import("./+create-party/create-party.routes"),
        canActivate: [AuthorizationGuard],
        data: {
            pageTitle: "Create Your Party",
            returnToExternal: "/experience-updates/park-reservations",
            analyticsPageKey: "wdw.site.admissionreservation.create-party",
            analyticsAutoTrack: false,
        } as RouteData,
    },
    {
        path: "select-date-and-park",
        loadChildren: () =>
            import("./+select-date-and-park/select-date-and-park.routes"),
        canActivate: [AuthorizationGuard, SessionGuard],
        data: {
            pageTitle: "Select Date and Park",
            check: ["selectedGuests"],
            returnTo: ViewName.CREATE_PARTY,
            analyticsPageKey:
                "wdw.site.admissionreservation.select-date-and-park",
            analyticsAutoTrack: true,
        } as RouteData,
    },
    {
        path: "checking-tickets",
        loadChildren: () =>
            import("./+segment-detection/segment-detection.routes"),
        canActivate: [AuthorizationGuard, SessionGuard],
        data: {
            pageTitle: "Checking Tickets",
            check: ["selectedGuests", "selectedDate", "selectedPark"],
            returnTo: ViewName.SELECT_DATE_AND_PARK,
            analyticsPageKey: "wdw.site.admissionreservation.checking-tickets",
            analyticsAutoTrack: true,
        } as RouteData,
    },
    {
        path: "unable-to-reserve",
        loadChildren: () =>
            import("./+unable-to-reserve/unable-to-reserve.routes"),
        canActivate: [AuthorizationGuard, SessionGuard],
        data: {
            pageTitle: "Just a Moment",
            check: ["eligibleSegments"],
            returnTo: ViewName.SELECT_DATE_AND_PARK,
            analyticsPageKey: "wdw.site.admissionreservation.unable-to-reserve",
            analyticsAutoTrack: true,
        } as RouteData,
    },
    {
        path: "select-time",
        loadChildren: () => import("./+select-time/select-time.routes"),
        canActivate: [AuthorizationGuard, SessionGuard],
        data: {
            pageTitle: "Select a Time",
            check: [
                "selectedGuests",
                "selectedDate",
                "selectedPark",
                "selectedSegment",
            ],
            returnTo: ViewName.SELECT_DATE_AND_PARK,
            analyticsPageKey: "wdw.site.admissionreservation.select-time",
            analyticsAutoTrack: false,
        } as RouteData,
    },
    {
        path: "review-and-confirm",
        loadChildren: () =>
            import("./+review-and-confirm/review-and-confirm.routes"),
        canActivate: [AuthorizationGuard, SessionGuard],
        data: {
            pageTitle: "Review and Confirm",
            check: ["selectedGuests", "selectedPark", "selectedOffer"],
            returnTo: ViewName.SELECT_TIME,
            analyticsPageKey:
                "wdw.site.admissionreservation.review-and-confirm",
            analyticsAutoTrack: false,
        } as RouteData,
    },
    {
        path: "confirmation",
        loadChildren: () => import("./+confirmation/confirmation.routes"),
        canActivate: [AuthorizationGuard, SessionGuard],
        data: {
            pageTitle: "Congratulations!",
            check: ["selectedGuests", "selectedPark", "createdEntitlement"],
            returnTo: ViewName.CREATE_PARTY,
            analyticsPageKey: "wdw.site.admissionreservation.confirmation",
            analyticsAutoTrack: false,
        } as RouteData,
    },
];
